/**
 * 广告位banner
 */
import { getBanner } from '@/js/banner'
import { getAppBanner } from '@/js/house/appindex';

export const banner = {
    namespaced: true,
    state: {
        index: {}, // 首页
        mapping: {}, // 勘察
        team: {}, // 服务团队
        remark: {}, // 合同备忘录
        overReport: {}, // 现场交底单
        ending: {}, // 竣工评价
    },
    mutations: {
        /**
         * 首页banner
         */
        changeIndex(state, payload) {
            state.index = payload
        },
        /**
         * 勘察报告banner
         */
        changeMapping(state, payload) {
            state.mapping = payload
        },
        /**
         * 服务团队banner
         */
        changeTeam(state, payload) {
            state.team = payload
        },
        /**
         * 合同备忘录banner
         */
        changeRemark(state, payload) {
            state.remark = payload
        },
        /**
         * 现场交底单banner
         */
        changeOver(state, payload) {
            state.overReport = payload
        },
        /**
         * 竣工评价banner
         */
        changeEnding(state, payload) {
            state.ending = payload
        },
    },
    actions: {
        /**
         * @param adment_id 7：首页；8：勘察报告；9：服务团队；10：合同备忘录；11：现场交底单；12：竣工评价
         */
        async getData({commit, state}, payload) {
            await getBanner(payload).then(res => {
                const RESULT = res.data.data.result

                switch (payload) {
                    case 7:
                        commit('changeIndex', RESULT);
                        break;
                    case 8:
                        commit('changeMapping', RESULT);
                        break;
                    case 9:
                        commit('changeTeam', RESULT);
                        break;
                    case 10:
                        commit('changeRemark', RESULT);
                        break;
                    case 11:
                        commit('changeOver', RESULT);
                        break;
                    case 12:
                        commit('changeEnding', RESULT);
                        break;
                }
            })
        },
        async getAppBanner({commit, state}, data = {}) {
            await getAppBanner(data).then(res => {
                const RESULT = res.data.data.result
                switch (data.adment_id) {
                    case 7:
                        commit('changeIndex', RESULT);
                        break;
                    case 8:
                        commit('changeMapping', RESULT);
                        break;
                    case 9:
                        commit('changeTeam', RESULT);
                        break;
                    case 10:
                        commit('changeRemark', RESULT);
                        break;
                    case 11:
                        commit('changeOver', RESULT);
                        break;
                    case 12:
                        commit('changeEnding', RESULT);
                        break;
                }
            })
        },
    },
    getters: {

    },
}